// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3hifT","switch":"Checkbox_switch__1SNm9"};